module.exports = __webpack_public_path__ + "static/media/payroll.a1505a87.png";